import { FelaCSS } from '@bridebook/ui/src/components/fela/flowtypes';
import IconWrap from '@bridebook/ui/src/components/svg/icon-wrap';
import { IStylingProps } from '@bridebook/ui/src/themes/types';
import { TColor } from '@bridebook/ui/src/types';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconMessageIllustration = ({ id, color, width = 161, style, ...restProps }: IProps) => {
  const viewBoxWidth = 161;
  const viewBoxHeight = 160;

  const icon = ({ width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      fill="none"
      width={`${width}px`}
      height={`${height}px`}>
      <circle cx="80.5" cy="80" r="80" fill="#DFF6F1" />
      <path
        d="M76.3985 83.3373L70.301 108.348C70.0746 109.276 70.0332 110.239 70.1791 111.182C70.3251 112.126 70.6555 113.031 71.1514 113.847C71.6474 114.663 72.2993 115.373 73.0698 115.937C73.8403 116.5 74.7143 116.907 75.6419 117.133L105.967 124.526C106.747 133.087 113.832 133.72 116.627 134.013C116.655 134.015 116.682 134.007 116.705 133.991C116.728 133.976 116.745 133.953 116.753 133.927C116.762 133.901 116.761 133.872 116.752 133.846C116.743 133.82 116.725 133.798 116.702 133.783C114.695 132.56 114.095 129.206 113.962 126.475L116.213 127.023C117.14 127.25 118.103 127.291 119.047 127.145C119.99 126.999 120.896 126.669 121.712 126.173C122.527 125.677 123.237 125.025 123.801 124.255C124.365 123.484 124.771 122.61 124.997 121.682L131.095 96.6717C131.321 95.7442 131.362 94.7812 131.217 93.8377C131.071 92.8942 130.74 91.9887 130.244 91.1729C129.748 90.3571 129.096 89.647 128.326 89.0833C127.555 88.5195 126.681 88.113 125.754 87.8871L85.183 77.9963C84.2555 77.7699 83.2925 77.7285 82.349 77.8744C81.4055 78.0204 80.4999 78.3508 79.6842 78.8467C78.8684 79.3427 78.1583 79.9946 77.5945 80.7651C77.0308 81.5356 76.6243 82.4097 76.3985 83.3373Z"
        fill="#B8BAF4"
      />
      <path
        d="M126.706 95.6755L109.749 91.5415C109.637 91.5143 109.525 91.5827 109.498 91.6944L108.628 95.2627C108.6 95.3744 108.669 95.487 108.781 95.5142L125.738 99.6482C125.849 99.6755 125.962 99.607 125.989 99.4953L126.859 95.927C126.886 95.8153 126.818 95.7027 126.706 95.6755Z"
        fill="white"
      />
      <path
        d="M124.287 105.606L78.3428 94.4048C78.2312 94.3775 78.1186 94.446 78.0913 94.5577L77.2214 98.126C77.1942 98.2377 77.2626 98.3503 77.3743 98.3775L123.319 109.578C123.431 109.606 123.543 109.537 123.57 109.426L124.44 105.857C124.468 105.746 124.399 105.633 124.287 105.606Z"
        fill="#D4E5FF"
      />
      <path
        d="M121.866 115.539L75.9209 104.338C75.8093 104.311 75.6967 104.38 75.6695 104.491L74.7995 108.06C74.7723 108.171 74.8408 108.284 74.9524 108.311L120.897 119.512C121.009 119.539 121.121 119.471 121.148 119.359L122.018 115.791C122.046 115.679 121.977 115.567 121.866 115.539Z"
        fill="#D4E5FF"
      />
      <path
        d="M93.4672 53.3386L103.438 85.3582C103.808 86.5455 103.941 87.7942 103.828 89.0328C103.715 90.2714 103.36 91.4757 102.782 92.5768C102.203 93.678 101.414 94.6544 100.458 95.4503C99.5026 96.2462 98.3995 96.8461 97.2119 97.2155L58.389 109.305C58.0748 120.499 48.9152 121.901 45.305 122.51C45.2691 122.515 45.2328 122.507 45.2016 122.489C45.1705 122.471 45.1463 122.443 45.133 122.409C45.1197 122.375 45.118 122.338 45.1282 122.304C45.1383 122.269 45.1598 122.239 45.1891 122.218C47.6988 120.463 48.2039 116.053 48.1549 112.491L45.2724 113.389C44.0851 113.759 42.8365 113.891 41.5979 113.779C40.3594 113.666 39.1552 113.311 38.0541 112.732C36.953 112.154 35.9766 111.365 35.1807 110.409C34.3848 109.454 33.785 108.351 33.4155 107.163L23.4445 75.1434C23.0744 73.9561 22.9419 72.7074 23.0545 71.4688C23.1671 70.2302 23.5227 69.0259 24.1009 67.9248C24.6791 66.8236 25.4686 65.8472 26.4242 65.0512C27.3799 64.2553 28.4831 63.6555 29.6706 63.286L81.6097 47.1125C82.7971 46.7424 84.0457 46.6099 85.2843 46.7225C86.523 46.8351 87.7272 47.1907 88.8284 47.7689C89.9295 48.347 90.906 49.1365 91.7019 50.0922C92.4978 51.0479 93.0977 52.151 93.4672 53.3386Z"
        fill="#7175E9"
      />
      <path
        d="M56.7778 64.804L28.9644 73.4538C28.8546 73.488 28.7933 73.6046 28.8274 73.7144L30.2859 78.404C30.32 78.5138 30.4367 78.5751 30.5465 78.541L58.3599 69.8912C58.4697 69.857 58.531 69.7404 58.4968 69.6306L57.0384 64.9409C57.0042 64.8312 56.8876 64.7699 56.7778 64.804Z"
        fill="white"
      />
      <path
        d="M91.872 67.7794L32.9331 86.1334C32.8233 86.1676 32.7621 86.2843 32.7963 86.394L34.2563 91.0826C34.2905 91.1923 34.4072 91.2536 34.5169 91.2194L93.4558 72.8654C93.5656 72.8312 93.6269 72.7145 93.5927 72.6048L92.1326 67.9162C92.0984 67.8065 91.9818 67.7452 91.872 67.7794Z"
        fill="#D4E5FF"
      />
      <path
        d="M95.8234 80.5574L36.8706 98.8913C36.7609 98.9255 36.6995 99.0421 36.7337 99.1519L38.1921 103.842C38.2263 103.951 38.3429 104.013 38.4527 103.978L97.4055 85.6445C97.5153 85.6104 97.5766 85.4937 97.5424 85.3839L96.084 80.6943C96.0498 80.5845 95.9332 80.5232 95.8234 80.5574Z"
        fill="#D4E5FF"
      />
      <ellipse
        cx="85.038"
        cy="44.2622"
        rx="15.7729"
        ry="15.7729"
        transform="rotate(-24.186 85.038 44.2622)"
        fill="#FF766A"
      />
      <path
        d="M84.7284 43.5085C85.4821 43.1701 86.2061 43.0087 86.9004 43.0244C87.5977 43.0324 88.2244 43.2263 88.7803 43.6061C89.3339 43.9805 89.7799 44.5446 90.1184 45.2982C90.4881 46.1213 90.6336 46.9103 90.5551 47.6649C90.4741 48.4143 90.1689 49.1005 89.6395 49.7237C89.11 50.3469 88.3616 50.8757 87.3941 51.3102C86.7794 51.5863 86.1808 51.7909 85.5983 51.9241C85.0212 52.0548 84.4921 52.0997 84.0113 52.0588L83.2479 50.359C83.7496 50.4035 84.3135 50.3718 84.9395 50.2641C85.5632 50.151 86.1315 49.9792 86.6447 49.7488C87.1899 49.5039 87.6215 49.2137 87.9397 48.8781C88.2579 48.5425 88.4468 48.1622 88.5064 47.7372C88.5714 47.3098 88.4898 46.8422 88.2618 46.3344C87.9593 45.6609 87.51 45.2397 86.9138 45.0707C86.3205 44.8939 85.5669 45.0108 84.6529 45.4213C84.3322 45.5653 84.0033 45.7483 83.6663 45.9704C83.3322 46.1847 83.0592 46.3779 82.8475 46.55L81.8021 46.4319L79.6684 40.5013L85.7617 37.7646L86.5071 39.4242L82.0734 41.4155L83.1276 44.4491C83.3008 44.32 83.5126 44.1766 83.7631 44.0192C84.0111 43.8564 84.3329 43.6862 84.7284 43.5085Z"
        fill="white"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconMessageIllustration;
